namespace $ {
	/**
	* Key names code for hotkey
	* @see [mol_hotkey](../../hotkey/hotkey.view.ts)
	*/
	export enum $mol_keyboard_code {
		backspace = 8,
		tab = 9,
		enter = 13,
		shift = 16,
		ctrl = 17,
		alt = 18,
		pause = 19,
		capsLock = 20,
		escape = 27,
		space = 32,
		pageUp = 33,
		pageDown = 34,
		end = 35,
		home = 36,
		left = 37,
		up = 38,
		right = 39,
		down = 40,
		insert = 45,
		delete = 46,
		key0 = 48,
		key1 = 49,
		key2 = 50,
		key3 = 51,
		key4 = 52,
		key5 = 53,
		key6 = 54,
		key7 = 55,
		key8 = 56,
		key9 = 57,
		A = 65,
		B = 66,
		C = 67,
		D = 68,
		E = 69,
		F = 70,
		G = 71,
		H = 72,
		I = 73,
		J = 74,
		K = 75,
		L = 76,
		M = 77,
		N = 78,
		O = 79,
		P = 80,
		Q = 81,
		R = 82,
		S = 83,
		T = 84,
		U = 85,
		V = 86,
		W = 87,
		X = 88,
		Y = 89,
		Z = 90,
		metaLeft = 91,
		metaRight = 92,
		select = 93,
		numpad0 = 96,
		numpad1 = 97,
		numpad2 = 98,
		numpad3 = 99,
		numpad4 = 100,
		numpad5 = 101,
		numpad6 = 102,
		numpad7 = 103,
		numpad8 = 104,
		numpad9 = 105,
		multiply = 106,
		add = 107,
		subtract = 109,
		decimal = 110,
		divide = 111,
		F1 = 112,
		F2 = 113,
		F3 = 114,
		F4 = 115,
		F5 = 116,
		F6 = 117,
		F7 = 118,
		F8 = 119,
		F9 = 120,
		F10 = 121,
		F11 = 122,
		F12 = 123,
		numLock = 144,
		scrollLock = 145,
		semicolon = 186,
		equals = 187,
		comma = 188,
		dash = 189,
		period = 190,
		forwardSlash = 191,
		graveAccent = 192,
		bracketOpen = 219,
		slashBack = 220,
		slashBackLeft = 226,
		bracketClose = 221,
		quoteSingle = 222
	}
}
